module.exports = __webpack_public_path__ + "img/Turks and Caicos.985c0eeb.svg";